var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Modal } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { twitterActions } from 'components/settings/actions/twitter';
import { getTwitterToken } from 'components/settings/api/twitter';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import styles from '../../twitterSettings.module.scss';
import { TwitterConnect } from './components/twitterConnect/twitterConnect';
import { TwitterDetails } from './components/twitterDetails/twitterDetails';
export const TwitterModal = ({ account, buttonProps, }) => {
    const notify = useNotifications();
    const queues = useAppSelector((state) => state.settings.queues.queues);
    const [modalOpen, setModalOpen] = useState(false);
    const [twitterToken, setTwitterToken] = useState();
    const [twitterAccount, setTwitterAccount] = useState();
    const [asyncStatus, setAsyncStatus] = useState('succeeded');
    const dispatch = useAppDispatch();
    const defaultQueue = queues.find((queue) => queue.is_default);
    useEffect(() => {
        setTwitterAccount(account);
    }, [account]);
    const handleCloseModal = () => {
        setModalOpen(false);
        // Only clear account if were in the connect flow otherwise we're editing
        if (!account) {
            setTwitterAccount(undefined);
        }
        dispatch(twitterActions.readAccounts());
    };
    const handleConnect = (account) => {
        setTwitterToken(undefined);
        setTwitterAccount(account);
    };
    function handleAddTwitter() {
        return __awaiter(this, void 0, void 0, function* () {
            if (twitterAccount) {
                setModalOpen(true);
            }
            else {
                try {
                    setAsyncStatus('loading');
                    const response = yield getTwitterToken();
                    window.open(response.data.authorize_url, '_blank', 'toolbar=0,location=0,menubar=0,height=800,width=600');
                    setTwitterToken(response.data);
                    setModalOpen(true);
                    setAsyncStatus('succeeded');
                }
                catch (error) {
                    notify({
                        title: 'An error occurred when trying to fetch the Twitter token.',
                    }, NotificationType.Error);
                    setAsyncStatus('failed');
                }
            }
        });
    }
    // keep track of add vs edit to provide correct initial values and texts
    const view = account ? 'edit' : 'add';
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onClick: handleAddTwitter, isLoading: asyncStatus === 'loading' }, buttonProps)), _jsxs(Modal, Object.assign({ isOpen: modalOpen, onClose: handleCloseModal, className: styles.modal }, { children: [twitterAccount && (_jsx(TwitterDetails, { initialValues: {
                            twitterName: view === 'edit'
                                ? twitterAccount.alias_name
                                : twitterAccount.screen_name,
                            queue: queues.find((queue) => queue.id === twitterAccount.queue_id) ||
                                defaultQueue,
                            mentions: twitterAccount.tweets_enabled,
                        }, twitterData: twitterAccount, onCloseModal: handleCloseModal, view: view })), twitterToken && defaultQueue && (_jsx(TwitterConnect, { twitterToken: twitterToken, onCloseModal: handleCloseModal, onConnect: handleConnect, defaultQueue: defaultQueue }))] }))] }));
};
